export const TEST_CASES_UPDATE_STATE = "TEST_CASES_UPDATE_STATE"